// Contenu à faire valider par un juriste.
// Les repères [À COMPLÉTER : …] signalent les informations encore inconnues :
// ne rien inventer, les remplacer par les données exactes.
import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection, ToComplete } from '../components/LegalLayout';
import { contactInfo } from '../config/siteConfig';
import { siteInfo } from '../mockData';

const LegalNotice = () => (
  <LegalLayout title="Mentions légales">
    <LegalSection title="Éditrice du site">
      <ul className="space-y-1">
        <li><strong>Nom :</strong> {siteInfo.name}</li>
        <li><strong>Profession :</strong> {siteInfo.title}</li>
        <li><strong>Statut :</strong> <ToComplete>statut juridique (ex. entreprise individuelle, profession libérale)</ToComplete></li>
        <li><strong>Adresse :</strong> {contactInfo.address}</li>
        <li>
          <strong>Téléphone :</strong>{' '}
          <a href={contactInfo.phoneHref} className="text-[#21167D] underline underline-offset-2">{contactInfo.phone}</a>
        </li>
        <li>
          <strong>Email :</strong>{' '}
          <a href={`mailto:${contactInfo.email}`} className="text-[#21167D] underline underline-offset-2 break-all">{contactInfo.email}</a>
        </li>
        <li><strong>Numéro ADELI ou RPPS :</strong> <ToComplete>numéro ADELI ou RPPS</ToComplete></li>
        <li><strong>SIRET :</strong> <ToComplete>numéro SIRET</ToComplete></li>
      </ul>
    </LegalSection>

    <LegalSection title="Directrice de la publication">
      <p>
        {siteInfo.name} <ToComplete>confirmer la directrice de la publication</ToComplete>
      </p>
    </LegalSection>

    <LegalSection title="Hébergeur">
      <ul className="space-y-1">
        <li><strong>Raison sociale :</strong> Cloudflare, Inc.</li>
        <li><strong>Adresse :</strong> <ToComplete>adresse postale de Cloudflare, Inc., à vérifier sur cloudflare.com</ToComplete></li>
        <li><strong>Téléphone :</strong> <ToComplete>numéro de téléphone de Cloudflare, Inc., à vérifier sur cloudflare.com</ToComplete></li>
      </ul>
    </LegalSection>

    <LegalSection title="Données personnelles">
      <p>
        Le traitement des données saisies dans les formulaires du site est décrit dans la{' '}
        <Link to="/politique-de-confidentialite" className="text-[#21167D] underline underline-offset-2">politique de confidentialité</Link>.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default LegalNotice;
